export const PICKER_CLASS = 'faceplate-picker';
